export const environment = {
  firebase: {
    apiKey: "AIzaSyBWpMb9-IlrjkRe0t0tQu3cQ0xPjYj_5Yo",
    authDomain: isFtc() ? "staging.ftc.nexus" : 'staging.frc.nexus',
    databaseURL: isFtc() ? 'https://nexus-ftc-staging.firebaseio.com' : "https://frc-virtual-queue-staging-default-rtdb.firebaseio.com",
    projectId: "frc-virtual-queue-staging",
    storageBucket: "frc-virtual-queue-staging.appspot.com",
    messagingSenderId: "874281191270",
    appId: "1:874281191270:web:edecc76f37eb25d3ce6aa7",
    measurementId: "G-45PMZMGZRP"
  },
  production: true,
  useEmulatedFunctions: false,
  emulatedHandoutsUrl: false,
  emulatedSignsUrl: false,
  hostUrl: isFtc() ? 'https://staging.ftc.nexus' : 'https://staging.frc.nexus',
  shortUrl: isFtc() ? 'ftc.nexus' : 'frc.nexus',
  slackClientId: '3810479091186.4154573173825',
  csaSlackClientId: '3810479091186.4753211754963',
  discordClientId: '1109270028882288660',
  program: isFtc() ? 'FTC' : 'FRC',
  intlTelInputUtilsUrl: isFtc() ? 'https://staging.ftc.nexus/en/assets/scripts/intl-tel-input-utils.js' : 'https://staging.frc.nexus/en/assets/scripts/intl-tel-input-utils.js',
  matchCountSeed: isFtc() ? 0 : 32558,
  eventRegistrationType: isFtc() ? 'event' : 'offseason',
  demoTeamNumbers: isFtc() ? {min: 99900, max: 99999} : {min: 9970, max: 9999},
  timedAllianceSelectionStart: !isFtc(),
  phoneNumberLimit: isFtc() ? 3 : 5,
  inspectionStartAction: isFtc() ? 'Start inspection' : 'Start weigh-in',
  matchImportFirstColor: isFtc() ? 'red' : 'blue',
  matchImportFieldNumber: isFtc(),
  queuingLeadTime: isFtc() ? '7 minutes' : '15 minutes',
  testAreaIsCalledPracticeField: isFtc(),
  matchDuration: (isFtc() ? 158 : 163) * 1000,
};

function isFtc() {
  return window.location.hostname.includes('ftc.nexus');
}
